import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSettingsList, getLoadingStatus, getSavingStatus } from '../../redux/settings/selectors';
import { settingsActions } from '../../redux/settings/actions';

export const useSettingsData = () => {
  const dispatch = useDispatch();
  const [settingsFormData, setSettingsFormData] = useState();
  const [settingsFormFieldsData, setSettingsFormFieldsData] = useState();
  const settingsData = useSelector(getSettingsList);
  const loading = useSelector(getLoadingStatus);
  const saving = useSelector(getSavingStatus);

  useEffect(() => {
    dispatch(settingsActions.loadSettingsList());
  }, [dispatch]);

  useEffect(() => {
    if (!settingsData) return;
    let formData = {};
    settingsData.data.forEach(element => {
      formData[element.key] = element.value.is_enabled;
      formData['alertLevel' + element.key] = element.value.alert_level;
    });

    setSettingsFormData(formData);
  }, [settingsData]);

  useEffect(() => {
    if (!settingsData) {
      setSettingsFormFieldsData([]);
      return;
    }
    setSettingsFormFieldsData(settingsData.data);
  }, [settingsData]);

  return { settingsFormData, loading, saving, settingsFormFieldsData };
};
